<template>
    <div class="chaptering-container h-inherit pointer disable-selection">
        <div class="row no-gutters">
          <DefaultSidebarMenuComponent v-if="!$store.getters.instanceInReadOnly" :key="'default-sidebar-lang-' + $i18n.locale"/>

          <div v-for="chapter in chapters" :key="chapter.id" class="one-chapter col-lg-12">

            <!-- Chapter -->
            <div class="row no-gutters"
                 v-on:click="clickOnChapter(chapter)"
                 v-on:dblclick="doubleClickOnChapter(chapter)"
                 :class="{
                        selectedChapter: ($store.getters.getSelectedChapterId === chapter.id) && ($store.getters.getSelectedEntryId === null),
                        setAsCurrent: isSelectedChapter(chapter),
                        currentTimestamp: $store.state.currentVideoTimestamp === chapter.timestamp  && $store.state.currentVideoTimestamp !== 0
                        }">
              <!-- Chapter Timpestamp -->
              <div class="col-lg-3 col-md-4 col-5 pt-2 br text-center timing-header">
                <h3>{{ $moment().startOf('day').seconds(chapter.timestamp).format('HH:mm:ss') }}</h3>
              </div>

              <!-- Chapter Title -->
              <div class="col-lg-9 col-md-8 col-7">
                <h3 class="chapter-header">
                  {{ chapter.title }}
                </h3>
              </div>
            </div>

            <!-- Entries -->

            <div class="row no-gutters" v-for="entry in chapter.entries"
                 v-on:click="clickOnEntry(chapter, entry)"
                 v-on:dblclick="doubleClickOnEntry(chapter, entry)"
                 :class="{
                     selectedEntry: $store.getters.getSelectedEntryId === entry.id,
                     setAsCurrent: isSelectedEntry(entry),
                     currentTimestamp: $store.state.currentVideoTimestamp === entry.timestamp && $store.state.currentVideoTimestamp !== 0
                     }">
              <!-- Entry Timpestamp -->
              <div class="col-lg-3 col-md-4 col-5 br text-center timing" :class="getEntryBackgroundColor(entry)">
                <span class="">{{ $moment().startOf('day').seconds(entry.timestamp).format('HH:mm:ss') }}</span>
              </div>

              <!-- Entry Title -->
              <div class="col-lg-9 col-md-8 col-7 chapter-entry-container" :class="getEntryBackgroundColor(entry)">
                        <span class="chapter-entry">
                            {{ entry.text }}
                        </span>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import DefaultSidebarMenuComponent from '../../Sidebar/DefaultMode/DefaultSidebarMenuComponent';

import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

const ChapterLiveRepository = RepositoryFactory.get('chaptersLive');
const InstanceRepository = RepositoryFactory.get('instances');


export default {
  name: 'DefaultChapterEntryList',
  components: { DefaultSidebarMenuComponent },
  props: ['chapters'],
  data() {
    return {};
  },
  methods: {
    	/**
         * Determines if the given chapter is the one that is currently set.
         */
	    isSelectedChapter(chapter) {
		    if (!this.$store.getters.instanceInLiveMode) { return false; }
		    if (this.$store.getters.instanceLiveData.currentChapter === null) { return false; }

		    return chapter.id === this.$store.getters.instanceLiveData.currentChapter;
	    },
	    /**
	     * Determines if the given entry is the one that is currently set.
	     */
	    isSelectedEntry(entry) {
		    if (!this.$store.getters.instanceInLiveMode) { return false; }
		    if (this.$store.getters.instanceLiveData.currentEntry === null) { return false; }

		    return entry.id === this.$store.getters.instanceLiveData.currentEntry;
	    },
    /*
        SINGLE CLICK
       */
    clickOnChapter(chapter) {
      if (this.$store.getters.instanceInReadOnly) { return false; }
      const currentlySelectedChapter = this.$store.getters.getSelectedChapterId;
      const currentlySelectedEntry = this.$store.getters.getSelectedEntryId;

      if (currentlySelectedChapter === chapter.id && currentlySelectedEntry !== null) {
        this.$store.commit('setSelectedEntryId', null);
      } else if (currentlySelectedChapter === chapter.id) {
        this.$store.commit('setSelectedChapterId', null);
      } else {
        this.$store.commit('setSelectedChapterId', chapter.id);
      }
    },
    clickOnEntry(chapter, entry) {
      if (this.$store.getters.instanceInReadOnly) { return false; }
      const currentlySelectedEntry = this.$store.getters.getSelectedEntryId;

      if (currentlySelectedEntry === entry.id) {
        // If the entry that has been selected before is selected
        this.$store.commit('setSelectedChapterId', null);
        this.$store.commit('setSelectedEntryId', null);
      } else {
        this.$store.commit('setSelectedChapterId', chapter.id);
        this.$store.commit('setSelectedEntryId', entry.id);
      }
    },

    /*
        Double Click
       */
    doubleClickOnChapter(chapter) {
      if (this.$store.getters.instanceInReadOnly) { return false; }
      if (this.$store.getters.instanceInLiveMode) {
        // If instance in live mode: Set the selected chapter to the current timestamp.
        ChapterLiveRepository.setChapter(chapter.id).then(() => InstanceRepository.refetchActive(false));
      } else if (this.$store.getters.instanceInPostProcessingMode) {
        // If instance in post processing mode: Set the selected chapter to the current timestamp of the running video.
        if (this.$store.getters.getVideoTimestamp !== -1) { ChapterLiveRepository.setChapter(chapter.id, null, this.$store.getters.getVideoTimestamp).then(() => InstanceRepository.refetchActive(false)); }
      }
    },
    doubleClickOnEntry(chapter, entry) {
      if (this.$store.getters.instanceInReadOnly) { return false; }
      // if (this.$store.getters.instanceInLiveMode) {
      //   // If instance in live mode: Set the selected chapter to the current timestamp.
      //   ChapterLiveRepository.setChapter(chapter.id, entry.id).then(() => InstanceRepository.refetchActive(false));
      // } else
      if (this.$store.getters.instanceInPostProcessingMode) {
        // If instance in post processing: Set the selected chapter to the current timestamp of the running video.
        if (this.$store.getters.getVideoTimestamp !== -1) { ChapterLiveRepository.setChapter(chapter.id, entry.id, this.$store.getters.getVideoTimestamp).then(() => InstanceRepository.refetchActive(false)); }
      }
    },


    getEntryBackgroundColor(entry) {
      if (this.$store.getters.instanceInReadOnly) { return ''; }

      return entry.order % 2 && this.$store.getters.getSelectedEntryId !== entry.id ? 'entry-grey' : '';
    },
  },
};
</script>

<style>
    .selectedChapter, .selectedEntry {
        color: white;
        background-color: #00a6d4;
        font-weight: bold;
    }

    .setAsCurrent {
        color: #e24646;
        font-weight: bold;
    }

    .currentTimestamp {
        color: #47a44b !important;
        font-weight: 800 !important;
    }
</style>
